import { Button, HStack } from '@genial/components';
import React from 'react';

export interface SecondCopyActionsProps {
  buttonDisabled: boolean;
  handlePressButton: () => void;
}

export const SecondCopyActions: React.FC<SecondCopyActionsProps> = ({
  buttonDisabled,
  handlePressButton,
}) => {
  return (
    <HStack justifyContent="flex-end">
      <Button onPress={handlePressButton} isDisabled={buttonDisabled}>
        Continuar
      </Button>
    </HStack>
  );
};
